// extracted by mini-css-extract-plugin
module.exports = {"heading":"pageLayout_heading__1qzpQ"};